function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY
import * as React from 'react';
export default function FlagMC(props) {
  return /*#__PURE__*/React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAVUExURdIYLtwcM+YgOP39/fj4+PT09PLy8qTTCSQAAAEmSURBVDjL1U1JkgMhDDM/AF4w5AWpSh6QqqbvfcCc59L8/wkjGcgyh66cpiaiLcuyoOV0jC/5iEA6xXRijY8ndUKLXmKMKbE6zwrD8xJohBRiQDPRKQbz8YsAcG90F2QCLww1Wgx3xBk4xDsB54M3SXY4E64HPBCcE6ydc5y84wjXdjIsKIFtmUeBBWksxBmQEFyh2QnXeJHHwGccHe7lF0Z4qqf+Abgc4/wvAssTrpeHHDjL1YZsZzHCzMSScRa8kAlYfT8LlHnxJtzSeEVPoFvgCO8ESllXlpaiOVOXvGZoazdRs5QRhNAxqGlc0XUTa2o7W6jawPe42PCCGnoC3bgMCy9A1Kp7rbuiAWTKqg1qk9baPtFqa3VHwWqcav1m4Ah/EfgBN+bzTroU15EAAAAASUVORK5CYII=",
    alt: "MC"
  }, props));
}